import { render, staticRenderFns } from "./BaaTemplateBuilder.vue?vue&type=template&id=1cbbc28a&scoped=true&"
import script from "./BaaTemplateBuilder.vue?vue&type=script&lang=js&"
export * from "./BaaTemplateBuilder.vue?vue&type=script&lang=js&"
import style0 from "./BaaTemplateBuilder.vue?vue&type=style&index=0&id=1cbbc28a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbbc28a",
  null
  
)

export default component.exports